module.exports = __webpack_public_path__ + "img/limpieza2.752deffc.jpg";